import React, { useContext, useEffect } from 'react';
import { useSidebar } from '../../../context/AdminContext';
import { MenuData } from './MenuData';
import SidebarMenuItem from './SidebarMenuItem';
import '../../../assets/css/admin/adminPageLayout/adminsidebar.css';
import AppContext from '../../../context/AppContext';
import logo from '../../../assets/images/logo.jpg';
const AdminSidebar = () => {
  const { isSidebarOpen } = useSidebar();
  const {authToken,setAuthToken}=useContext(AppContext);
  useEffect(()=>{
    console.log("-----------------ndwnfsnn------");
    const token=localStorage.getItem("adminToken");
    setAuthToken(token);
    console.log(authToken);
  },[]);

  return (
    <aside className={`jj-sidebar ${isSidebarOpen ? 'jj-sidebar-open' : 'jj-sidebar-collapsed'}`}>
      <div className="jj-sidebar-header">
        {isSidebarOpen ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
  <img src={logo} className="adm-sdb-brand-logo" />
  <div>
    <h2 className="jj-sidebar-logo-text" style={{ margin: 0 }}>Journey Junction</h2>
    <span className="jj-sidebar-logo-subtitle">Admin Panel</span>
  </div>
</div>
        ) : (
          <img
    src={logo}
    alt="Journey Junction"
    className="adm-sdb-collapsed-logo"
  />
        )}
      </div>

      <nav className="jj-sidebar-nav">
        <div className="jj-sidebar-menu">
          {MenuData.map((item) => (
            <SidebarMenuItem key={item.id} item={item} />
          ))}
        </div>
      </nav>

      {isSidebarOpen && (
        <div className="jj-sidebar-footer">
        </div>
      )}
    </aside>
  );
};

export default AdminSidebar;